<template>
    <div class="order-confirmation-container content-section__column-manage-spacings order-manage-spacings order-manage-spacings-top-bottom">
        <div class="content plugin text-plugin text-container">
            <h2>Danke für dein Abo beim Öpfelchasper!</h2>
            <p>Wir haben deine Abobestellung erhalten und werden sie bearbeiten.
                <br> Damit auch nichts vergessen geht, haben wir dir eine Bestellbestätigung per E-Mail zugestellt.
                <br> <br>
            Hast du noch Fragen zu deiner Bestellung? Du erreichst uns telefonisch unter <a href="tel:+41438186152">043 818 61 52</a> oder per <a href="mailto:info@oepfelchasper.ch">info@oepfelchasper.ch</a>.</p>
            <p>
                <a class="button-link-plugin__link btn btn-default btn-md" href="/" role="button">Zurück zur Startseite</a>
            </p>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            mode: state => state.mode,
        }),
    },
    mounted() {
        window.scrollTo(0, 0);

        // GTM VirtualPageview
        const { dataLayer } = window;
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: 'VirtualPageview',
                virtualPageURL: `/de/${this.mode === 'business' ? 'bio-furs-buro' : 'bio-fur-dihei'}/bestaetigung`,
                virtualPageTitle: `Abo Bestellen ${this.mode === 'business' ? 'Büro' : 'Zuhause'} - Bestätigung`,
            });
        }
    },
    destroyed() {
        $('body').removeClass('body-illustrations body-illustrations--confirmation');
    }
};
</script>




// WEBPACK FOOTER //
// Confirmation.vue?67e29b74